<template>
  <div class="d-flex">
    <el-input
      v-model="displayFabric"
      :placeholder="$l('form_placeholder_displayFabric') || '请编辑面料'"
      type="textarea"
      class="mr-1"
      :rows="5"
      readonly
    />
    <el-button type="info" @click="editVisible = true">
      {{ $l('btn_editFabric') || '编辑面料' }}
    </el-button>

    <EditDialog
      :visible.sync="editVisible"
      :isFabricPosition="isFabricPosition"
      :faceFabric="faceFabric"
      :backFabric="backFabric"
      :innerFabric="innerFabric"
      @confirm="editConfirm"
    />
  </div>
</template>

<script>
import EditDialog from './edit.vue'
export default {
  components: { EditDialog },
  props: {
    isFabricPosition: { type: String, default: '' },
    faceFabric: { type: String, default: '' },
    backFabric: { type: String, default: '' },
    innerFabric: { type: String, default: '' },
    fabric: { type: String, default: '' },
  },
  data() {
    return { editVisible: false }
  },
  computed: {
    displayFabric() {
      if ('N' === this.isFabricPosition) return this.faceFabric
      const faceFabric = this.faceFabric
        ? `${this.$l('form_label_faceFabricEn') || 'Face'}: ${this.faceFabric}`
        : ''
      const backFabric = this.backFabric
        ? `${this.$l('form_label_backFabricEn') || 'Back'}: ${this.backFabric}`
        : ''
      const innerFabric = this.innerFabric
        ? `${this.$l('form_label_innerFabricEn') || 'Inner'}: ${
            this.innerFabric
          }`
        : ''
      return [faceFabric, innerFabric, backFabric].filter(Boolean).join(`\n`)
    },
  },
  watch: {
    displayFabric: {
      handler(val) {
        this.$emit('update:fabric', val)
      },
      immediate: true,
    },
  },
  methods: {
    editConfirm({ isFabricPosition, faceFabric, backFabric, innerFabric }) {
      this.$emit('update:isFabricPosition', isFabricPosition)
      this.$emit('update:faceFabric', faceFabric)
      this.$emit('update:backFabric', backFabric)
      this.$emit('update:innerFabric', innerFabric)
      this.$emit('change', {
        isFabricPosition,
        faceFabric,
        backFabric,
        innerFabric,
      })
    },
  },
}
</script>
